export default {
  lang: {
    confirm: {
      title: 'Você confirma que deseja remover? Não será restaurado após a exclusão',
      okText: 'Excluir',
      cancelText: 'Cancelamento',
    },
  },
};
